import React from "react";

import { StyledSVG } from "../StyledIcon";

export const QuestionIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <circle cx="9" cy="9" r="7.5" stroke={iconColor} strokeWidth="1.5" strokeLinejoin="round" />
      <path
        d="M6.83944 6.4456C6.96625 5.97235 7.22298 5.54403 7.58057 5.20911C7.93816 4.87418 8.38236 4.64602 8.86289 4.55044C9.34342 4.45485 9.84111 4.49566 10.2997 4.66825C10.7582 4.84083 11.1593 5.1383 11.4576 5.527C11.7558 5.9157 11.9393 6.38012 11.9874 6.8677C12.0354 7.35529 11.946 7.84659 11.7293 8.28601C11.5126 8.72543 11.1772 9.09543 10.7612 9.35416C10.3451 9.61288 9.86495 9.75 9.375 9.75"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.25 11.25C8.25 11.053 8.2791 10.858 8.33564 10.676C8.39217 10.494 8.47504 10.3286 8.5795 10.1893C8.68397 10.0501 8.80799 9.93956 8.94448 9.86418C9.08097 9.7888 9.22726 9.75 9.375 9.75"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8.25" cy="13.5" r="0.75" fill={iconColor} />
    </StyledSVG>
  );
};
